const state = {
    note: [],
    id: [],
    notebyleadid: [],
    loading: false
};

export default state;